module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/premium/premium-list/premium-list.component.css
// module id = ./src/app/premium/premium-list/premium-list.component.css
// module chunks = main